import { FaSort, FaDownload } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from '../Detalles/SesionDetalles';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE } from '../Config';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { useAppState } from './GraficoContext';
import { apiFetch } from '../apiClient';

let filterregrescarFiltros = 0;


interface SumaGenero {
    totalPoblacion?: number;
    masculino?: number;
    femenino?: number;
    noBinario?: number;
    noResponde?: number;
}

interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
    indicador: any
}

let COLORS = ['#88C4B3', '#628BB6', '#f8d107', '#ad7390'];

const Genero: React.FC<BarraProps> = ({ filtrar, codigoDivipola, indicador }) => {
    const { tieneGenero, setTieneGenero } = useAppState();
    const [sumaGenero, setdivipolaCantidad] = useState<SumaGenero>();
    const [cantidadNacional, setCantidadNacional] = useState<number>(0);
    let cargado = false;

    const fetchDatos = async () => {
        try {
            const startTime = performance.now();
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetSumaGeneros?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            const cantidadNacionalNuevo = 0;
            cargado = true;
            setCantidadNacional(cantidadNacionalNuevo);
            setdivipolaCantidad(data);
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const getDatos = async () => {
        console.log(DEFAULT_FILTER);
        if (DEFAULT_FILTER.regrescarFiltros != filterregrescarFiltros) {
            filterregrescarFiltros = DEFAULT_FILTER.regrescarFiltros;
            if (indicador != "") {
                fetchDatos();
            }
        }
    }

    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola, indicador]);
    const totalGenero = (sumaGenero?.masculino || 0) + (sumaGenero?.femenino || 0) + (sumaGenero?.noBinario || 0) + (sumaGenero?.noResponde || 0);
    let total = sumaGenero?.totalPoblacion || 0;
    if(total === 0 || isNaN(total)) {
        total = totalGenero;
    }
    const masculinoPorcentaje = ((sumaGenero?.masculino || 0) / total) * 100;
    const femeninoPorcentaje = ((sumaGenero?.femenino || 0) / total) * 100;
    const noBinarioPorcentaje = ((sumaGenero?.noBinario || 0) / total) * 100;
    const noRespondePorcentaje = ((sumaGenero?.noResponde || 0) / total) * 100;
    

    useEffect(() => {
        if (totalGenero === 0 || isNaN(totalGenero)) {
            setTieneGenero(false);
        } else {
            setTieneGenero(true);
        }
    }, [totalGenero, setTieneGenero]);

    if (totalGenero === 0 || isNaN(totalGenero)) {
        return <div></div>;
    }
    let COLORS2: string[];
    if (noBinarioPorcentaje == 0) {
        COLORS2 = ['#88C4B3', '#628BB6', '#ad7390'];
    }
    else {
        if (noRespondePorcentaje == 0) {
            COLORS2 = ['#88C4B3', '#628BB6', '#f8d107', '#ad7390'];
        }
        else {
            if (masculinoPorcentaje == 0) {
                COLORS2 = ['#628BB6', '#f8d107', '#ad7390'];
            }
            else {
                if (femeninoPorcentaje == 0) {
                    COLORS2 = ['#88C4B3', '#f8d107', '#ad7390'];
                }
                else {
                    COLORS2 = ['#88C4B3', '#628BB6', '#f8d107', '#ad7390'];
                }
            }
        }
    }

    return (
        <div style={{ alignItems: 'center', backgroundColor: '#fff', borderTop: '1px solid #ccc', float: 'left', margin: '10px 10px 0px 10px', padding: '10px 0px 0px 10px', width: '99%', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: '150px' }}>
            <table style={{ width: '100%', maxHeight: 200 }}>
                <tbody>
                    <tr>
                        <td style={{ width: '150px', textAlign: 'left', verticalAlign: "TOP" }}>
                            <h3 style={{ color: "#2c66a4", fontWeight: 'bold' }}>Género</h3><br />
                            <div style={{ paddingLeft: "20px" }}>
                                Total<br />
                                <b>{formatNumber(totalGenero)}</b>
                            </div>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <PieChart width={350} height={150}>
                                <Pie data={sumaGenero ? [
                                    { name: 'Masculino', value: sumaGenero.masculino || 0 },
                                    { name: 'Femenino', value: sumaGenero.femenino || 0 },
                                    { name: 'No Binario', value: sumaGenero.noBinario || 0 },
                                    { name: 'No Responde', value: sumaGenero.noResponde || 0 }
                                ].filter(entry => entry.value > 0) : []} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={25} outerRadius={40} fill="#8884d8" label={({ name, percent }) => `${name}: ${formatNumber((percent * 100))}%`} labelLine={true} style={{ fontSize: '10px' }}>
                                    {sumaGenero && Object.keys(sumaGenero).map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS2[index % COLORS2.length]} />
                                    ))}
                                </Pie>
                                <Tooltip formatter={(value: number) => `${formatNumber(value)}`} />
                            </PieChart>
                        </td>
                        <td style={{ width: '12.5%', textAlign: 'center', fontSize: '16px', color: COLORS[0] }}>
                            <div style={{ color: "Black" }}>Masculino</div>
                            <div style={{ fontWeight: 'bold' }}>{sumaGenero ? formatNumber(masculinoPorcentaje || 0) : '0'}%</div>
                            <div style={{ fontWeight: 'bold' }}>{sumaGenero ? formatNumber(sumaGenero.masculino || 0) : '0'}</div>
                        </td>
                        <td style={{ width: '12.5%', textAlign: 'center', fontSize: '16px', color: COLORS[1] }}>
                            <div style={{ color: "Black" }}>Femenino</div>
                            <div style={{ fontWeight: 'bold' }}>{formatNumber(femeninoPorcentaje)}%</div>
                            <div style={{ fontWeight: 'bold' }}>{formatNumber(sumaGenero?.femenino || 0)}</div>
                        </td>
                        <td style={{ width: '12.5%', textAlign: 'center', fontSize: '16px', color: COLORS[2] }}>
                            <div style={{ color: "Black" }}>No Binario</div>
                            <div style={{ fontWeight: 'bold' }}>{formatNumber(noBinarioPorcentaje)}%</div>
                            <div style={{ fontWeight: 'bold' }}>{formatNumber(sumaGenero?.noBinario || 0)}</div>
                        </td>
                        <td style={{ width: '12.5%', textAlign: 'center', fontSize: '16px', color: COLORS[3] }}>
                            <div style={{ color: "Black" }}>No Responde</div>
                            <div style={{ fontWeight: 'bold' }}>{formatNumber(noRespondePorcentaje)}%</div>
                            <div style={{ fontWeight: 'bold' }}>{formatNumber(sumaGenero?.noResponde || 0)}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Genero;